import * as React from 'react';
import styled from 'styled-components';

export const Header = ({ showHelp, onTabClick }) => {
  return (
    <StyledHeader>
      <HeaderLogo />
      <StyledNav>
        <TabButton active={!showHelp} onClick={() => onTabClick(false)}>
          Signatur
        </TabButton>
        <TabButton active={showHelp} onClick={() => onTabClick(true)}>
          Hjelp
        </TabButton>
      </StyledNav>
    </StyledHeader>
  );
};

const HeaderLogo = () => {
  return (
    <svg
      width="179"
      height="50"
      viewBox="0 0 179 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="logo"
    >
      <path
        d="M64.792 30.744C66.16 32.256 68.248 33.288 71.104 33.288C75.424 33.288 77.152 30.96 77.152 28.464C77.152 25.056 74.104 24.24 71.488 23.544C69.496 23.04 67.768 22.584 67.768 21.144C67.768 19.8 68.992 18.888 70.768 18.888C72.496 18.888 74.176 19.464 75.4 20.76L76.792 18.984C75.376 17.544 73.432 16.752 70.96 16.752C67.624 16.752 65.296 18.672 65.296 21.312C65.296 24.576 68.272 25.32 70.84 25.992C72.88 26.52 74.704 27 74.704 28.68C74.704 29.832 73.792 31.152 71.2 31.152C68.968 31.152 67.24 30.096 66.16 28.896L64.792 30.744ZM79.9323 33H82.3323V16.992H79.9323V33ZM85.2368 25.008C85.2368 30 88.9568 33.312 93.5408 33.312C96.2528 33.312 98.4608 32.184 99.9968 30.48V24.6H92.4608V26.712H97.5968V29.592C96.8288 30.312 95.3168 31.176 93.5408 31.176C90.2048 31.176 87.7088 28.584 87.7088 25.008C87.7088 21.408 90.2048 18.864 93.5408 18.864C95.4128 18.864 97.0208 19.8 97.9328 21.024L99.8768 19.896C98.5328 18.096 96.5408 16.728 93.5408 16.728C88.9568 16.728 85.2368 20.016 85.2368 25.008ZM114.321 33H116.649V16.992H114.249V28.992L105.537 16.992H103.065V33H105.465V20.712L114.321 33ZM131.622 33H134.262L127.902 16.992H124.902L118.542 33H121.182L122.478 29.688H130.326L131.622 33ZM126.39 19.08L129.63 27.552H123.174L126.39 19.08ZM138.501 33H140.901V19.104H145.845V16.992H133.533V19.104H138.501V33ZM148.346 26.736C148.346 30.672 150.602 33.288 155.09 33.288C159.578 33.288 161.81 30.696 161.81 26.712V16.992H159.386V26.664C159.386 29.4 157.898 31.152 155.09 31.152C152.282 31.152 150.77 29.4 150.77 26.664V16.992H148.346V26.736ZM174.601 33H177.385L173.281 26.592C175.321 26.328 177.265 24.792 177.265 21.912C177.265 18.96 175.177 16.992 172.129 16.992H165.385V33H167.785V26.832H170.785L174.601 33ZM174.793 21.912C174.793 23.592 173.545 24.72 171.817 24.72H167.785V19.104H171.817C173.545 19.104 174.793 20.232 174.793 21.912Z"
        fill="#fff"
      />
      <path
        d="M24.6796 35.7616C22.9743 35.0359 22.6114 34.3828 22.6114 32.7138V28.2509H26.131C30.3399 28.2509 33.1519 26.4004 33.1519 22.899C33.1519 19.3976 30.3399 17.5472 26.1128 17.5472H17.2415V17.6016C18.4388 18.2728 18.7109 19.0711 18.7109 20.7946V32.5868C18.7109 34.3103 18.457 35.0904 17.2415 35.7798V35.8342H24.6796V35.7616ZM22.6296 18.2366H24.8973C27.8907 18.2366 29.2877 20.1415 29.2877 22.9172C29.2877 25.6929 27.9089 27.5978 24.8973 27.5978H22.6296V18.2366ZM33.424 12.413L34.5851 15.3883H34.7846L35.9457 12.413L36.8891 15.2432H37.7599L36.1271 10.3448H35.9276L34.6939 13.4834L33.4603 10.3448H33.2607L31.628 15.2432H32.4806L33.424 12.413Z"
        fill="#AB7858"
      />
      <rect
        x="0.786164"
        y="0.786164"
        width="48.4277"
        height="48.4277"
        stroke="#AB7858"
        strokeWidth="1.57233"
      />
    </svg>
  );
};

const StyledHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 64px;
  float: left;
  background: black;

  .logo {
    width: 130px;
    height: 50px;
  }
`;

const StyledNav = styled.div`
  display: flex;
  position: absolute;
  left: 350px;
  bottom: 0;
  z-index: 2;
  user-select: none;
  @media screen and (max-width: 800px) {
    display: none;
  }
`;

const TabButton: any = styled.div`
  background: ${(props: any) => (props.active ? 'white' : '#444')};
  line-height: 48px;
  margin-right: 2px;
  padding: 0 50px;
  font-weight: 600;
  color: ${(props: any) => (props.active ? 'black' : 'white')};

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    cursor: pointer;
    background: ${(props: any) =>
      props.active ? 'white' : 'rgb(232, 200, 147)'};
    color: black;
  }
`;
